var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquareRemoveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.454,
    height: 25.454,
    viewBox: "0 0 25.454 25.454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M22.727,32h-20A2.727,2.727,0,0,0,0,34.727v20a2.727,2.727,0,0,0,2.727,2.727h20a2.727,2.727,0,0,0,2.727-2.727v-20A2.727,2.727,0,0,0,22.727,32ZM9.812,51.883C3.548,45.619,10.167,52.237,9.812,51.883Z",
    transform: "translate(818.273 261.773)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-818.273 -293.773)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "times-square",
    transform: "translate(818.273 291.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M22.727,1.818h-20A2.727,2.727,0,0,0,0,4.545v20a2.727,2.727,0,0,0,2.727,2.727h20a2.727,2.727,0,0,0,2.727-2.727v-20a2.727,2.727,0,0,0-2.727-2.727ZM19.636,18.244a.682.682,0,0,1,0,.966l-2.25,2.244a.682.682,0,0,1-.966,0l-3.693-3.727-3.7,3.727a.682.682,0,0,1-.966,0L5.818,19.2a.682.682,0,0,1,0-.966l3.727-3.693-3.727-3.7a.682.682,0,0,1,0-.966l2.25-2.25a.682.682,0,0,1,.966,0l3.693,3.733,3.7-3.727a.682.682,0,0,1,.966,0l2.25,2.25a.682.682,0,0,1,0,.966l-3.733,3.693Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M5.818,10.846a.682.682,0,0,1,0-.966l2.25-2.25a.682.682,0,0,1,.966,0l3.693,3.733,3.7-3.727a.682.682,0,0,1,.966,0l2.25,2.25a.682.682,0,0,1,0,.966l-3.733,3.693,3.727,3.7a.682.682,0,0,1,0,.966l-2.25,2.244a.682.682,0,0,1-.966,0l-3.693-3.727-3.7,3.727a.682.682,0,0,1-.966,0L5.818,19.2a.682.682,0,0,1,0-.966l3.727-3.693Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareRemoveIcon);
export default __webpack_public_path__ + "static/media/squareRemove-icon.8eab90cebc61ab2265fd582a3c6308ec.svg";
export { ForwardRef as ReactComponent };